import React from 'react';
import { Box, Grid } from '@mui/material';
import logoSvg from '@/assets/logo_medireco_top.svg';
import { ColorPalettes } from '../registration/constants/ColorPalettes';
import Layout from '../registration/components/Layout';
import { PageSegment } from '..';

export const TopPage = (props: {
  setActivePage: React.Dispatch<React.SetStateAction<PageSegment>>;
  facilityName?: string;
}) => {
  return (
    <>
      <Layout noMyPage={true} title={props.facilityName}>
        <Box sx={{ p: 2 }}>
          <Grid container justifyContent="center">
            <Grid item container xs={8} justifyContent="center">
              <Grid item mt={10} mb={6}>
                <img src={logoSvg} width={240} height={240} alt="" />
              </Grid>
              <Grid item container direction="column" rowSpacing={2}>
                <Grid item>
                  <SignUpButton onClick={() => props.setActivePage(PageSegment.Registration)} />
                </Grid>
                <Grid item>
                  <LoginButton onClick={() => props.setActivePage(PageSegment.Login)} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Layout>
    </>
  );
};

const SignUpButton = (props: { onClick: () => void }) => {
  return (
    <button
      type="submit"
      onClick={props.onClick}
      style={{
        width: '100%',
        height: '48px',
        color: ColorPalettes.MAIN,
        borderColor: ColorPalettes.MAIN,
        textAlign: 'center',
        margin: 'auto'
      }}
      className="bg-transparent flex relative border-2 rounded"
    >
      <div className="text-md m-auto">{'新規登録'}</div>
    </button>
  );
};

const LoginButton = (props: { onClick: () => void }) => {
  return (
    <button
      type="submit"
      onClick={props.onClick}
      style={{ width: '100%', height: '48px', color: '#FFFFFF', textAlign: 'center', margin: 'auto' }}
      className="bg-primary flex relative rounded"
    >
      <div className="text-md m-auto">{'ログイン'}</div>
    </button>
  );
};
